import React, { useContext, useEffect, useState } from 'react';
import { PeFilterContext } from '../../Contexts/PeFilterContext';
import MultiSelectEntity from '../RefineSearch/MultiSelectEntity';
import Popup from '../Common/Popup';

/**
 * The SectorFilter function is a component that renders a filter for selecting sectors,
 * with options that can be checked or unchecked.
 * @returns The SectorFilter component is returning a JSX element.
 */
function SectorFilter({ SectorOptions, setSectorOptions, customPathname, label = "Sector", isPopupOpen, setIsPopupOpen }) {

    const { Sectors, refineSearchFilters } = useContext(PeFilterContext);
    const [internalPopupOpen, setInternalPopupOpen] = useState(false);
    const popupOpen = isPopupOpen !== undefined ? isPopupOpen : internalPopupOpen;
    const setPopupOpen = setIsPopupOpen !== undefined ? setIsPopupOpen : setInternalPopupOpen;

    useEffect(() => {
        const ids = refineSearchFilters[customPathname]?.sector?.map(value => value.id) ?? [];
        setSectorOptions(Sectors?.map(option => ({ ...option, isChecked: ids.includes(option.id) })));
    }, [Sectors, customPathname, refineSearchFilters, setSectorOptions])


    const handleSectorChange = (e) => {
        const { name, checked, id, filteredIds } = e.target;
        let updatedOptions;

        if (name === "allSelect") {
            updatedOptions = SectorOptions.map((sector) => ({ ...sector, isChecked: checked }));
        } else if (name === "filteredSelect" && filteredIds) {
            updatedOptions = SectorOptions.map((sector) => {
                if (filteredIds.includes(sector.id)) {
                    return { ...sector, isChecked: checked };
                }
                return sector;
            });
        } else {
            updatedOptions = SectorOptions.map((sector) =>
                sector.id == id ? { ...sector, isChecked: checked } : sector
            );
        }

        setSectorOptions(updatedOptions);
    };

    const selectedSectorLength = SectorOptions?.filter(option => option.isChecked)?.length ?? 0

    return (
        <div className="relative w-full md:inline-block">
            <button
                type="button"
                className="h-10 rounded-md px-4 py-1 text-gray-500 hover:bg-gray-100 text-sm shadow-md border border-gray-300 text-left flex items-center justify-between w-full md:w-[90%]"
                onClick={() => setPopupOpen(!popupOpen)}
            >
                <span className="truncate pr-2">{label} <span className="opacity-60 ml-2 text-xs text-ellipsis">e.g. IT Products, BPO</span></span>
                <div className="flex items-center gap-2 flex-shrink-0">
                    {selectedSectorLength > 0 && (
                        <span className="bg-white rounded-full px-2 py-0.5 text-xs font-medium border border-gray-400">
                            {selectedSectorLength}
                        </span>
                    )}
                    <span className={`transition-transform duration-200 text-xl font-semibold ${popupOpen ? 'rotate-[270deg]' : 'rotate-90'}`}>
                        ›
                    </span>
                </div>
            </button>

            {popupOpen && (
                <Popup onClose={() => setPopupOpen(false)}>
                    <div className="p-4">
                        <MultiSelectEntity
                            handleEntityChange={handleSectorChange}
                            primaryEntity={SectorOptions}
                            showAll={true}
                            field="sector"
                        />
                    </div>
                </Popup>
            )}
        </div>
    )
}

export default SectorFilter